import request from '@/utils/request'
import store from '@/store'
// 【操作日志】 日志列表
export function logList(data, busBusinessId) {
  return request({
    headers: { busBusinessId: busBusinessId },
    url: '/api/v1/log-center/p/log/platformSearch',
    method: 'post',
    data
  })
}

// 【操作日志】 日志详情（全量）
export function logInfo(params) {
  return request({
    url: '/api/v1/log-center/p/log/detail',
    method: 'get',
    params
  })
}
